import { OperatorValue } from "@/config/operatorConfig";
import { isLegacyCondition } from "@/features/segments/builder/conditions";
import type { FormCondition, FormRule } from "@/features/segments/builder/schemas";
import type { SegmentField } from "@/features/segments/types";

export type DemoCondition = FormCondition & Required<Pick<FormCondition, "operator">>;

const isDemoCondition = (condition: FormCondition, fields: SegmentField[]): condition is DemoCondition =>
  condition.operator === OperatorValue.IS_ANY_OF && !condition.isInverted && !isLegacyCondition(condition, fields);

export const findDemoConditionIndex = (rule: FormRule | undefined, fields: SegmentField[]) =>
  rule?.conditions.findIndex((condition) => isDemoCondition(condition, fields)) ?? -1;

export const findDemoCondition = (rule: FormRule | undefined, fields: SegmentField[]) =>
  rule?.conditions.find((condition): condition is DemoCondition => isDemoCondition(condition, fields));

export const getOfferedOperators = (fields: SegmentField[]) => [
  ...new Set(fields.flatMap((field) => field.operators)),
];
